import React from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay/hooks';
import { useParams } from 'react-router';
import ScheduleTemplateTablePanel from '~/panels/ScheduleTemplateTablePanel';
export const ScheduleTemplatesPage = () => {
    const { scheduleId } = useParams();
    const { schedule } = useLazyLoadQuery(graphql `
      query ScheduleTemplatesPageQuery($scheduleId: ID!) {
        schedule(id: $scheduleId) {
          ...ScheduleTemplateTablePanel_schedule
        }
      }
    `, {
        scheduleId,
    });
    return <ScheduleTemplateTablePanel scheduleRef={schedule}/>;
};
export default ScheduleTemplatesPage;
